export { default as HeroBannerMultiple } from './HeroBannerMultiple';
